import { Inject, Injectable } from '@angular/core';
import { AppService } from '../../app.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationSchedulesService {
 private _campaignsApiBaseUrl: string = '';
  
  public constructor(private appService: AppService, public http: HttpClient, @Inject('CAMPAIGNS_API_BASE_URL') baseurl: string) {
    this._campaignsApiBaseUrl = baseurl;
  }

  public get = (creditorId: string): Observable<any> => {
    let result: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    const apipath: string = 'notification-schedule/creditor/'+creditorId;
    const fullPath: string = this._campaignsApiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();

    return this.http.get<any>(fullPath, options);
  }

  public post = (creditorId: number, day: string, preferredTime: string, startTime: string, endTime: string, isActive: boolean): Observable<any> => {
    const apipath: string = 'notification-schedule/create';
    const fullPath: string = this._campaignsApiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = { 
          CreditorId: creditorId, 
          Day: day, 
          PreferredTimeUtc: preferredTime, 
          StartTimeUtc: startTime,
          EndTimeUtc: endTime,
          CreatedOn: new Date().toISOString(),
          CreatedBy: this.appService.getCurrentSession().AuthenticatedUser.User.Email
        };

    return this.http.post<any>(fullPath, params, options);
  }


  public put = (notificationScheduleId: number, creditorId: number, day: string, preferredTime: string, startTime: string, endTime: string, isActive: boolean, createdBy: string, createdOnUtc: any): Observable<any> => {
    const apipath: string = 'notification-schedule/update';
    const fullPath: string = this._campaignsApiBaseUrl + apipath;
    const options = this.appService.getHttpHeaderOptions();
    const params: any = { 
      NotificationScheduleId: notificationScheduleId,
      CreditorId: creditorId, 
      Day: day, 
      PreferredTimeUtc: preferredTime, 
      StartTimeUtc: startTime,
      EndTimeUtc: endTime,
      IsActive: isActive,
      CreatedOn: createdOnUtc,
      CreatedBy: createdBy,
      UpdatedBy: this.appService.getCurrentSession().AuthenticatedUser.User.Email,
      UpdatedOn: new Date().toISOString(),
    };

    return this.http.put<any>(fullPath, params, options);
  }
}

